import React from 'react'
import ReactDOM from 'react-dom'
import EventsContainer from './events/EventsContainer'
import EventsProps from './events/types/EventsProps'
import Category from './events/types/Category'
import Event from './events/types/Event'

import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom"

interface Response {
  meta: {
    location: Array<Category>,
    audience: Array<Category>,
    type: Array<Category>,
    language: Array<Category>,
    series: Array<Category>,
  },
  data: Array<Event>,
}

if (document.getElementById('events-container')) {
  const cache = Math.floor((new Date()).getTime() / (1000 * 60 * 15)); // Refetch api every 15 mins
  // const cache = Math.floor((new Date()).getTime() / 1); // Refetch api instantly
  fetch('/events.json?' + cache)
  .then(res => res.json())
  .then((res: Response) => {
    const location: Array<Category> = res.meta.location.map(e => { return { slug: e.slug, title: e.title } })
    const audience: Array<Category> = res.meta.audience.map(e => { return { slug: e.slug, title: e.title } })
    const type: Array<Category> = res.meta.type.map(e => { return { slug: e.slug, title: e.title } })
    const language: Array<Category> = res.meta.language.map(e => { return { slug: e.slug, title: e.title } })
    const series: Array<Category> = res.meta.series.map(e => { return { slug: e.slug, title: e.title } })

    const data: EventsProps = {
      events: res.data,
      location: location,
      audience: audience,
      type: type,
      language: language,
      series: series
    }

    ReactDOM.render((
      <Router basename="/">
        <Switch>
          <Route path='/:terms?'>
            <EventsContainer {...data} />
          </Route>
        </Switch>
      </Router>
    ), document.getElementById('events-container'))
  })
}